<template>
  <div>
    <div v-if="showModal"
      class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
      <div class="relative w-full h-full max-w-2xl md:h-auto">
        <!--content-->
        <div class="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <!--header-->
          <div class="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
            <h3 class="text-3xl font-semibold">
              Detail API
            </h3>
            <button
              class="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
              v-on:click="toggleModal()">
              <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                ×
              </span>
            </button>
          </div>
          <!--body-->
          <div class="relative p-6 flex-auto">
            <div class="flex-auto px-0 lg:px-0 py-0 pt-0">
              <div class="flex">
                <div class="w-full lg:w-4/12 mr-3">
                  <label class="block text-sm font-medium text-gray-700 mb-2">Client Name</label>
                  <select v-model="filter.client_name"
                    class="px-4 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    @change="getAppNames()">
                    <option v-for="(item, key) in filterClients['client_name']" :value="item" :key="key">
                      {{ item }}
                    </option>
                  </select>
                </div>
                <div class="w-full lg:w-4/12 mr-3">
                  <label class="block text-sm font-medium text-gray-700 mb-2">App Name</label>
                  <select v-model="filter.app_name"
                    class="px-4 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    @change="getVersions()">
                    <option v-for="(item, key) in filterClients['app_name']" :value="item" :key="key">
                      {{ item }}
                    </option>
                  </select>
                </div>
                <div class="w-full lg:w-4/12 mr-3">
                  <label class="block text-sm font-medium text-gray-700 mb-2">Version</label>
                  <select v-model="filter.version_old"
                    class="px-4 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                    <option v-for="(item, key) in filterClients['version']" :value="item" :key="key">
                      {{ item }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="flex py-5">
                <div class="w-full lg:w-4/12 mr-3">
                  <label class="block text-sm font-medium text-gray-700 mb-2">New Version</label>
                  <input type="text" v-model="filter.version_new" name="version"
                    class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150" />
                </div>
              </div>
            </div>
          </div>
          <!--footer-->
          <div class="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
            <button
              class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
              type="button" v-on:click="save()">
              Save
            </button>
            <button
              class="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
              type="button" v-on:click="toggleModal()">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { UseAppStore } from '@/stores/AppStore';
import APIDataService from "@/services/APIDataService";
import { useToast } from "vue-toastification";
import FilterDataService from "@/services/FilterDataService";
import ErrorHandler from "@/ErrorHandler";

export default {
  setup() {
    const appStore = UseAppStore();
    const toast = useToast();
    // appStore.resetBreadcrumbs();
    // appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    // appStore.putBreadcrumbs("api-management", "API Management", "/admin/api-management")
    return {
      appStore,
      toast
    }
  },
  props: {
    showModal: Boolean,
    toggleModal: { type: Function },
    clientNamesProps: Array
  },
  data() {
    return {
      alertType: '',
      alertMessage: '',
      client: {},
      filter: {},
      filterClients: { client_name: this.clientNamesProps }
    }
  },
  components: {

  },
  methods: {
    getAppNames() {
      this.filter = {
        client_name: this.filter.client_name
      }
      this.filterClients['version'] = []
      FilterDataService.search(this.filter)
        .then(response => {
          this.filterClients['app_name'] = response.data["data"]["list"];
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    getVersions() {
      this.filter = {
        client_name: this.filter.client_name,
        app_name: this.filter.app_name,
      }
      this.filterClients['intention'] = []
      FilterDataService.search(this.filter)
        .then(response => {
          this.filterClients['version'] = response.data["data"]["list"];
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    save() {
      APIDataService.save(this.filter)
        .then(response => {
          // this.client = response.data["data"]["apis"][0]
          console.log(response)
          this.toast.success('Clone Success')
          this.countDownTimer(3, document.location = '/admin/api-management')
        })
        .catch(e => {
          this.toast.error(e.response.data['code_message']);
        });
    },
    countDownTimer(countDown, callback) {
      if (countDown > 0) {
        setTimeout(() => {
          countDown -= 1
          this.countDownTimer(countDown, callback)
        }, 1000)
      } else {
        this.alertType = ''
        if (callback != undefined) {
          callback()
        }
      }
    }
  },

  watch: {
    clientNamesProps: function (newVal, oldVal) { // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      if (newVal) {
        this.filterClients['client_name'] = newVal
      }
    }
  }

};
</script>
